<script setup>
import ApplicationLogo from '@/components/ApplicationLogo.vue';
import LinkText from '@/components/links/LinkText.vue';
</script>

<template>
  <div class="text-center">
    <LinkText
      as="a"
      href="/">
      <ApplicationLogo
        class="mx-auto h-10 w-auto"
        aria-hidden="true" />
      <span class="sr-only">Traxo</span>
    </LinkText>
  </div>

  <div
    v-if="$slots.default"
    class="mt-6 text-center">
    <slot />
  </div>
</template>
